import store from '../index'
import cloneDeep from 'lodash.clonedeep'
import {
  API,
  callToaster,
  getMayaCookieNameChatSlug,
  getMayaCookieNameChatToken,
  logToConsole,
  SocketsClass,
} from '../../utils'
import { toast } from 'react-toastify'
import cookie from 'react-cookies'
import { logAction } from '../../utils/actionLogger'
import {
  RESET_MAYA_STATE,
  IS_PLAN_REQUESTED,
  IS_CHAT_READY,
  ANIMATE_DEFAULT_MESSAGES,
  FETCH_ORGANIZATION_DETAILS,
  SET_REGENERATE_RESPONSE,
  ADD_NEW_MESSAGE,
  REMOVE_EXISTING_MESSAGE,
  FETCH_CHAT,
  SET_FETCH_INTENT_STATE,
  SET_INTENT_GRID,
  SET_IS_GRID_MODE,
  ADD_MAYA_RESPONSE,
  SET_MAYA_CHAT_RESPONSE,
  IS_MAYA_RESPONDING,
  SET_SOCKET_CONNECTION_ESTABLISHED,
  FETCH_DEFAULT_CHAT,
  GET_DEFAULT_TRIPS,
  IS_EXPECTING_ASSISTANT_RESPONSE,
  SET_IS_TEST_CASE,
  DEFAULT_SEARCH_RESULTS,
  SET_SEARCH_QUERY,
  FETCH_SEARCH_RESULTS_FULFILLED,
  SET_IS_FETCHING_SEARCH_RESULTS,
  FETCH_SEARCH_RESULTS_REJECTED,
  SET_MAYA_AI_QUERY_RESPONSE,
  SET_IS_FETCHING_AI_QUERY_RESPONSE,
  SET_MAYA_AI_QUERY_TOKEN,
  SET_IS_INTERNAL_CASE,
  SET_GENERATE_AI_QUERY_RESPONSE,
  SET_IS_INTERNAL_CASE_IN_QUERY_OR_OPTIONS,
  SET_ORGANIZATION_DETAILS_ERROR,
  FETCH_ORGANIZATION_DETAILS_FULFILLED,
  SET_SHOW_FEEDBACK_MODAL,
  SEND_FEEDBACK,
  SET_USER_HAS_SENT_MESSAGE,
  SET_LAST_ACTIVE_TIME,
  UPDATE_EXISTING_MESSAGE,
  SET_BRAND,
  UPDATE_ASSISTANT_RESPONSE_ID,
  ADD_POPOVER_NOTIFICATION_MESSAGE,
} from './constants'
import axios from 'axios'
import { io } from 'socket.io-client'
import { getTranslations, incMayaDailyMessagesCount } from '../../utils'
import { setIsPopoverChatOpen } from '../general/actions'

const userMessagesToSend = [] // ARRAY TO STORE USER MESSAGES TO SEND TO MAYA
let socketInstance = SocketsClass.getInstance()
// let socket = null // GLOBAL SOCKET VARIABLE
// let socketSet = false // INFO ABOUT WHETHER SOCKET IS SET OR NOT
// let socketRoomName = null // SOCKET ROOM USER CONNECTS TO AT START OF SESSION

// SEPARATE AXIOS INSTANCE FOR INTENT FETCHING
const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 900000,
})

export const resetMayaState = payload => dispatch =>
  dispatch({ type: RESET_MAYA_STATE, payload: payload })

export const fetchOrganizationDetails = () => {
  instance
    .get(`/organization`, {
      headers: {
        'Content-Type': 'application/json',
        'Organization-Key': store.getState().general.organizationKey,
        'Organization-Slug': store.getState().general.organizationSlug,
        'Organization-Client': store.getState().general.organizationClientSlug,
        'Organization-Intro-Type': store.getState().general.introType,
        'Organization-Mode':
          store.getState().general.widgetMode === 'search'
            ? store.getState().general.widgetMode
            : 'chat',
        'Organization-Url': window.location.href,
        language: store.getState().general.language,
      },
    })
    .then(data => {
      store.dispatch({
        type: FETCH_ORGANIZATION_DETAILS_FULFILLED,
        payload: data?.data,
      })
      return {
        ...data,
      }
    })
    .catch(err => {
      const widgetMode = store.getState().general.widgetMode
      logToConsole('WIDGET MODE IS', widgetMode)
      if (widgetMode != 'popover') {
        store.dispatch({
          type: SET_ORGANIZATION_DETAILS_ERROR,
          payload: err?.response?.data?.message || 'Something went wrong',
        })
      }
      logToConsole('Error fetching organization details', err)
    })
}

export const animateDefaultMessages = async (
  messages,
  messageIndex,
  messageCharacterIndex
) => {
  // ALL DEFAULT MESSAGES ANIMATED
  // SET UP IS CHAT READY TO FALSE FOR SHOWING LOADER AND DISABLING SEND BUTTON
  store.dispatch({ type: IS_CHAT_READY, payload: false })

  let messageToSend = cloneDeep(messages[messageIndex])

  // DO NOT SHOW DISCLAIMER INITIALLY
  // DISCLAIMER WILL ONLY BE SHOWING AT THE END
  delete messageToSend['disclaimer']

  // ANIMATE 5 CHARACHTERS PER ITERATION
  let newMessageCharacterIndex = cloneDeep(messageCharacterIndex + 5)
  messageToSend.content = messageToSend.content.slice(
    0,
    newMessageCharacterIndex
  )

  // IF MESSAGE CHARACTER IS 0 THEN ITS A NEW MESSAGE
  store.dispatch({
    type: ANIMATE_DEFAULT_MESSAGES,
    payload: {
      message: messageToSend,
      isNewMessage: messageCharacterIndex === 0 ? true : false,
    },
  })

  const delay = ms => new Promise(resolve => setTimeout(resolve, ms))

  setTimeout(async () => {
    if (newMessageCharacterIndex < messages[messageIndex].content.length) {
      // IF CURRENT MESSAGE THEN ANIMATE NEXT CHARACTERS
      animateDefaultMessages(messages, messageIndex, newMessageCharacterIndex)
    } else {
      // NEW MESSAGE CASE

      // ANIMATE DISCLAIMER OF CURRENT MESSAGE BEFORE MOVING TO NEXT
      // ADD DISCLAIMER IF ANY OF PREVIOUS MESSAGE ALSO
      let disclaimerMessage = messages[messageIndex]['disclaimer'] || ''

      if (disclaimerMessage) {
        // IF DISCLAIMER MESSAGE LENGTH THEN ANIMATE THE MESSAGE

        let disclaimerMessageChunks = disclaimerMessage.match(/.{1,5}/g)
        messageToSend['disclaimer'] = ''
        for (let i = 0; i < disclaimerMessageChunks.length; i++) {
          messageToSend['disclaimer'] += disclaimerMessageChunks[i]

          store.dispatch({
            type: ANIMATE_DEFAULT_MESSAGES,
            payload: {
              message: messageToSend,
              isNewMessage: false,
            },
          })

          await delay(20) // Await for the timeout to complete before continuing
        }
      }

      messageToSend['disclaimer'] = messages[messageIndex]['disclaimer']
      store.dispatch({
        type: ANIMATE_DEFAULT_MESSAGES,
        payload: {
          message: messageToSend,
          isNewMessage: false,
        },
      })

      if (messageIndex < messages.length - 1) {
        // MOVE TO NEXT MESSAGE
        animateDefaultMessages(messages, messageIndex + 1, 0)
      } else {
        // ALL DEFAULT MESSAGES ANIMATED
        // SET UP IS CHAT READY FOR SHOWING MESSAGE SEND BUTTON
        store.dispatch({ type: IS_CHAT_READY, payload: true })
      }
    }
  }, 20)
}

export const fetchDefaultChat = () => {
  return {
    type: FETCH_DEFAULT_CHAT,
    payload: API.postRequest(`/chat`, {
      isTestChat: store.getState().maya.isTestCase,
      currentUrl: window.location.href,
      brand: store.getState().maya.brand,
    }).then(data => {
      if (data?.chatMessages?.length) {
        // IF DEFAULT MESSAGES THEN ANIMATE THOSE
        animateDefaultMessages(data.chatMessages, 0, 0)
      }
      return {
        ...data,
      }
    }),
  }
}

export const fetchChat = (slug, token) => {
  return {
    type: FETCH_CHAT,
    payload: API.getRequest(`/chat/${slug}?token=${token}`).then(data => {
      let defaultMessages = data?.defaultMessages
      let defaultMessagesLength =
        defaultMessages?.log?.conversationLog?.length || 0

      if (
        data?.chatMessages?.length &&
        data?.chatMessages?.length <= defaultMessagesLength
      ) {
        // IF CHAT HAS ONLY DEFAULT MESSAGES THEN IT'S A DEFAULT CHATE
        // ANIMATE DEFAULT CHAT
        animateDefaultMessages(cloneDeep(data.chatMessages), 0, 0)

        // DELETE MESSAGES AS MESSAGES WILL NOW ANIMATE
        delete data['chatMessages']
      } else {
        // SET UP IS CHAT READY FOR SHOWING MESSAGE SEND BUTTON
        // MESSAGES NOT ANIMATING IN THIS CASE
        store.dispatch({ type: IS_CHAT_READY, payload: true })
      }

      return {
        ...data,
      }
    }),
  }
}

// JOIN SOCKET ROOM ONLY INCASE OF CHAT
// SO THAT INCASE EVEN IF SOCKET ID CHANGES, SOCKET STILL GETS CHAT RESPONSES BASED ON CHAT SLUG
export const joinSocketRoom = slug => {
  if (
    socketInstance.getValues().socket &&
    socketInstance.getValues().socketSet
  ) {
    logToConsole('SOCKET.IO MAYA join_room', slug)
    // JOIN SOCKET ROOM BASED ON CHAT SLUG
    // SEND A SOCKET EVENT TO SERVER TO JOIN ROOM
    socketInstance.getValues().socket.emit('join_room', { roomId: slug })
  } else {
    setTimeout(() => {
      // KEEP ON CALLING UNTIL SOCKET ROOM IS JOINED
      // ALL CHATS ARE BASED ON SOCKET ROOMS
      joinSocketRoom(slug)
    }, 100)
  }
}

export const fetchSearchResults = body => {
  if (!body.searchTerm) {
    return
  }

  store.dispatch(setIsFetchingSearchResults(true))
  store.dispatch(setMayaAiQueryResponse(''))

  if (!store.getState().maya.isInternalCaseInQueryOrOptions) {
    // WON'T BE FETCHING AI QUERY RESPONSE IF generateAiQueryResponse TO FALSE
    store.dispatch(setIsFetchingAiQueryResponse(true))
  } else {
    // SHOW THE GENERATE AI QUERY CTA AGAIN
    store.dispatch(setGnerateAiQueryResponse(false))
  }
  instance
    .post(
      '/search/grid',
      {
        ...body,
        isTestSearch: store.getState().maya.isTestCase,
        brand: store.getState().maya.brand,
        isInternalSearch: store.getState().maya.isInternalCase,
        currentUrl: window.location.href,
        widgetMode: store.getState().general.widgetMode,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Organization-Key': store.getState().general.organizationKey,
          'Organization-Slug': store.getState().general.organizationSlug,
          'Organization-Mode': 'search',
          language: store.getState().general.language,
        },
      }
    )
    .then(({ data }) => {
      const searchResponse = data
      // SET INTENT RESPONSE
      store.dispatch({
        type: FETCH_SEARCH_RESULTS_FULFILLED,
        payload: searchResponse,
      })
      store.dispatch(setIsFetchingSearchResults(false))

      // IF SOCKET IS ALREADY SET AND SEARCH RESULTS BASED ON USER QUERY ARE FETCHED
      if (
        socketInstance.getValues().socket &&
        !store.getState().maya.defaultSearchResults &&
        !store.getState().maya.isInternalCaseInQueryOrOptions
      ) {
        setTimeout(() => {
          sendSearchQueryMessageToMaya()
        }, 100)
      }

      // NOT FETCHING SEARCH AI QUERY RESPONSE WHEN INTERNAL CASE
      if (store.getState().maya.isInternalCaseInQueryOrOptions) {
        store.dispatch(setIsFetchingAiQueryResponse(false))
      }

      if (!socketInstance.getValues().socket) {
        callToaster(toast.TYPE.ERROR, 'AI Search Response Failed!')
      }
    })
    .catch(function (err) {
      store.dispatch({ type: FETCH_SEARCH_RESULTS_REJECTED, payload: err })
      callToaster(toast.TYPE.ERROR, 'Search Failed')
      store.dispatch(setIsFetchingSearchResults(false))
      store.dispatch(setIsFetchingAiQueryResponse(false))
    })
}

export const setDefaultSearchResults = payload => dispatch =>
  dispatch({ type: DEFAULT_SEARCH_RESULTS, payload: payload })

export const setSearchQuery = payload => dispatch =>
  dispatch({ type: SET_SEARCH_QUERY, payload: payload })

export const sendSearchQueryMessageToMaya = async () => {
  let body = {}
  body.query = store.getState().maya.searchQuery
  body.searchGridOutput = store.getState().maya.searchResults
  body.slug = store.getState().maya.searchSlug
  body.organizationKey = store.getState().general.organizationKey
  body.organizationSlug = store.getState().general.organizationSlug
  body.language = store.getState().general.language
  body.isTestSearch = store.getState().maya.isTestCase
  body.brand = store.getState().maya.brand

  // SEND SOCKET EVENT TO BACKEND FOR AI SEARCH QUERY RESPONSE
  socketInstance.getValues().socket.emit('send_search_query_message', {
    ...body,
    currentUrl: window.location.href,
    widgetMode: store.getState().general.widgetMode,
  })
}

export const addUserMessageToSend = message => {
  userMessagesToSend.push(message)
}

export const sendMessageToMaya = async body => {
  // GET DAILY MESSAGES LIMIT FROM COOKIE
  const incrementedDailyMessagesCount = incMayaDailyMessagesCount()

  // SET USER HAS SENT MESSAGE TO TRUE
  // USED TO CHECK IF USER HAS DONE CONVERSATION AND THEN LATER BECOMES IDLE
  store.dispatch({ type: SET_USER_HAS_SENT_MESSAGE, payload: true })

  body.organizationKey = store.getState().general.organizationKey
  body.organizationSlug = store.getState().general.organizationSlug
  body.language = store.getState().general.language
  body.organizationIntroType = store.getState().general.introType
  body.fetchParallelIntent = true // TELL THE BACKEND TO FETCH PARALLEL INTENT
  body.brand = store.getState().maya.brand
  body.slug = store.getState().maya.slug
  body.token = store.getState().maya.token

  logToConsole('SENDING MESSAGE TO MAYA', body)

  // SET IS EXPECTING ASSISTANT RESPONSE TO TRUE
  // THIS LETS IT ACCEPT STREAMING RESPONSES ON CURRENT INSTANCE
  store.dispatch(isExpectingAssistantResponse(true))

  // SEND ROOM NAME IN EVERY MESSAGE IN ORDER TO RECEIVE RESPONSE
  socketInstance.getValues().socket.emit('send_message', {
    ...body,
    roomId: socketInstance.getValues().socketRoomName,
    currentUrl: window.location.href,
    widgetMode: store.getState().general.widgetMode,
    isTestChat: store.getState().maya.isTestCase,
    limitMessagesCase: store.getState().general.limitMessagesCase,
    userByPassMessagesLimit: store.getState().general.userByPassMessagesLimit,
    dailyMessagesCount: incrementedDailyMessagesCount,
  })
}

export const requestPlan = body => {
  // SET USER HAS SENT MESSAGE TO TRUE
  // USED TO CHECK IF USER HAS DONE CONVERSATION AND THEN LATER BECOMES IDLE
  store.dispatch({ type: SET_USER_HAS_SENT_MESSAGE, payload: true })

  // UPDATE LAST ACTIVE TIME
  // USED TO CHECK HOW LONG CONVERSATION HAS BEEN IN ACTIVE
  store.dispatch({
    type: SET_LAST_ACTIVE_TIME,
    payload: Date.now(),
  })

  body.organizationKey = store.getState().general.organizationKey
  body.organizationSlug = store.getState().general.organizationSlug
  body.language = store.getState().general.language

  // SET IS PLAN REQUESTED TO TRUE
  store.dispatch({ type: IS_PLAN_REQUESTED, payload: true })

  // SEND ROOM NAME IN EVERY MESSAGE IN ORDER TO RECEIVE RESPONSE
  socketInstance.getValues().socket.emit('request_plan', {
    ...body,
    roomId: socketInstance.getValues().socketRoomName,
  })
}

export const sendAssistantResponseFeedback = body => {
  // UPDATE LAST ACTIVE TIME
  // USED TO CHECK HOW LONG CONVERSATION HAS BEEN IN ACTIVE
  store.dispatch({
    type: SET_LAST_ACTIVE_TIME,
    payload: Date.now(),
  })

  body.organizationKey = store.getState().general.organizationKey
  body.organizationSlug = store.getState().general.organizationSlug
  body.language = store.getState().general.language

  // SEND ROOM NAME IN EVERY MESSAGE IN ORDER TO RECEIVE RESPONSE
  socketInstance.getValues().socket.emit('assistant_response_feedback', {
    ...body,
    roomId: socketInstance.getValues().socketRoomName,
  })
}

export const getDefaultTrips = () => {
  return {
    type: GET_DEFAULT_TRIPS,
    payload: API.getRequest(`/default-trips`, {
      currentUrl: window.location.href,
      widgetMode: store.getState().general.widgetMode,
      brand: store.getState().maya.brand,
    }).then(data => {
      return { ...data }
    }),
  }
}

export const sendFeedback = rating => {
  let slug = store.getState().maya.slug
  let token = store.getState().maya.token
  let language = store.getState().general.language

  return {
    type: SEND_FEEDBACK,
    payload: API.postRequest(`/feedback`, {
      slug,
      token,
      rating,
    })
      .then(data => {
        store.dispatch({ type: SET_SHOW_FEEDBACK_MODAL, payload: false })
        callToaster(
          toast.TYPE.SUCCESS,
          getTranslations('feedback_success_text'),
          {
            position: 'bottom-left',
            autoClose: 10000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            style: {
              background: '#4CAF50',
              color: 'white',
              fontWeight: 700,
            },
            className: 'white-toast-icon',
            closeButton: {
              style: {
                color: 'white',
              },
            },
          }
        )
        return { ...data }
      })
      .catch(err => {
        callToaster(toast.TYPE.ERROR, 'Something went wrong!')
        logToConsole(err)
      }),
  }
}

export const refreshChat = () => {
  let organizationDetails = store.getState().maya.organizationDetails
  let organizationSlug = store.getState().general.organizationSlug
  let language = store.getState().general.language

  logAction({ name: 'refresh_chat' })

  let cookieNameChatSlug = getMayaCookieNameChatSlug({
    language: language,
    organizationSlug: organizationSlug,
    chatMode: organizationDetails?.clients?.length ? 'b2b' : 'b2c',
  })

  let cookieNameChatToken = getMayaCookieNameChatToken({
    language: language,
    organizationSlug: organizationSlug,
    chatMode: organizationDetails?.clients?.length ? 'b2b' : 'b2c',
  })

  // REMOVE SLUG AND TOKEN FROM COOKIES
  cookie.remove(cookieNameChatSlug, {
    path: '/',
    domain: window.location.hostname,
  })
  cookie.remove(cookieNameChatToken, {
    path: '/',
    domain: window.location.hostname,
  })

  store.dispatch(fetchDefaultChat())
}

export const addPopoverNotificationMessage = message => dispatch =>
  dispatch({ type: ADD_POPOVER_NOTIFICATION_MESSAGE, payload: message })

export const setIsTestCase = boolean => dispatch =>
  dispatch({ type: SET_IS_TEST_CASE, payload: boolean })

export const setBrand = brand => dispatch =>
  dispatch({ type: SET_BRAND, payload: brand })

export const setIsInternalCase = boolean => dispatch =>
  dispatch({ type: SET_IS_INTERNAL_CASE, payload: boolean })

export const setIsInternalCaseInQueryOrOptions = boolean => dispatch =>
  dispatch({ type: SET_IS_INTERNAL_CASE_IN_QUERY_OR_OPTIONS, payload: boolean })

export const setGnerateAiQueryResponse = boolean => dispatch =>
  dispatch({ type: SET_GENERATE_AI_QUERY_RESPONSE, payload: boolean })

export const setRegenerateResponse = boolean => dispatch =>
  dispatch({ type: SET_REGENERATE_RESPONSE, payload: boolean })

export const isExpectingAssistantResponse = boolean => dispatch =>
  dispatch({ type: IS_EXPECTING_ASSISTANT_RESPONSE, payload: boolean })

export const updateAssistantResponseId = (tempId, id) => dispatch =>
  dispatch({ type: UPDATE_ASSISTANT_RESPONSE_ID, payload: { tempId, id } })

export const addNewMessage = message => dispatch =>
  dispatch({ type: ADD_NEW_MESSAGE, payload: message })

export const removeExistingMessage = message => dispatch =>
  dispatch({ type: REMOVE_EXISTING_MESSAGE, payload: message })

export const setFetchIntentState = boolean => dispatch =>
  dispatch({ type: SET_FETCH_INTENT_STATE, payload: boolean })

export const setIsFetchingSearchResults = boolean => dispatch =>
  dispatch({ type: SET_IS_FETCHING_SEARCH_RESULTS, payload: boolean })

export const setIsFetchingAiQueryResponse = boolean => dispatch =>
  dispatch({ type: SET_IS_FETCHING_AI_QUERY_RESPONSE, payload: boolean })

export const setIsGridMode = boolean => dispatch =>
  dispatch({ type: SET_IS_GRID_MODE, payload: boolean })

export const addMayaResponse = payload => dispatch =>
  dispatch({ type: ADD_MAYA_RESPONSE, payload: payload })

export const setMayaChatResponse = payload => dispatch =>
  dispatch({ type: SET_MAYA_CHAT_RESPONSE, payload: payload })

export const setMayaAiQueryResponse = payload => dispatch =>
  dispatch({ type: SET_MAYA_AI_QUERY_RESPONSE, payload: payload })

export const setMayaAiQueryToken = payload => dispatch =>
  dispatch({ type: SET_MAYA_AI_QUERY_TOKEN, payload: payload })

export const setIsMayaResponding = payload => dispatch =>
  dispatch({ type: IS_MAYA_RESPONDING, payload: payload })

export const setShowFeedbackModal = payload => dispatch => {
  dispatch({ type: SET_SHOW_FEEDBACK_MODAL, payload: payload })

  // If we're closing the modal, update the last active time to restart the timer
  if (payload === false) {
    logToConsole('Closing feedback modal')
    dispatch({ type: SET_LAST_ACTIVE_TIME, payload: Date.now() })
  }
}

export const updateLastActiveTime = payload => dispatch =>
  dispatch({ type: SET_LAST_ACTIVE_TIME, payload: Date.now() })

export const setSocketConnectionEstablished = payload => dispatch =>
  dispatch({ type: SET_SOCKET_CONNECTION_ESTABLISHED, payload: payload })

// SOCKETS HANDLING START

// HANDLE SOCKET CONNECTION
const handleSocketError = () => {
  callToaster(toast.TYPE.ERROR, 'Not able to connect to server!')
  store.dispatch(setIsMayaResponding(false))
  store.dispatch(setFetchIntentState(null))
  store.dispatch(isExpectingAssistantResponse(false))
}

// HANDLE SOCKET VALIDATION ERROR
const handleSocketValidationError = () => {
  callToaster(toast.TYPE.ERROR, 'Something went wrong!')
  store.dispatch(setIsMayaResponding(false))
  store.dispatch(setFetchIntentState(null))
  store.dispatch(isExpectingAssistantResponse(false))
}

// AS SOON AS ORGANIZATION CONFIG IS RECEIVED CONNECT SOCKET
// KEEP ON LOOPING UNTIL ORGANIZATION CONFIG FOUND AND SET
export const setSocketListeners = () => {
  logToConsole('SOCKET.IO MAYA SETTING UP => setSocketListeners')
  const organizationKey = store.getState().general.organizationKey
  const organizationSlug = store.getState().general.organizationSlug
  const language = store.getState().general.language

  if (
    organizationKey &&
    organizationSlug &&
    language &&
    socketInstance.getValues().socketSet
  ) {
    // ALL SET ALREADY
    return
  }

  if (
    organizationKey &&
    organizationSlug &&
    language &&
    !socketInstance.getValues().socketSet // IF SOCKET ISN'T ALREADY SET
  ) {
    // SET SOCKET SET VALUE
    socketInstance.setValues({ socketSet: true })

    logToConsole('SOCKET.IO MAYA SETTING UP')
    let tempSocket = io(`${process.env.REACT_APP_SOCKETS_URL}`, {
      transports: ['polling'],
      reconnection: true,
      cors: {},
      pingInterval: 20000,
      pingTimeout: 20000,
    })

    // SET SOCKET VALUE
    socketInstance.setValues({ socket: tempSocket })

    socketInstance.getValues().socket.onAny((event, data) => {
      if (event === 'receive_intent') {
        // UPDATE LAST ACTIVE TIME
        // USED TO CHECK HOW LONG CONVERSATION HAS BEEN IN ACTIVE
        store.dispatch({
          type: SET_LAST_ACTIVE_TIME,
          payload: Date.now(),
        })

        logToConsole('SOCKET.IO MAYA receive_intent', data)
        let intentTimestamp = store.getState().maya.isFetchingIntent
        if (data?.abusive) {
          // SET INTENT API CALL IN PROGRESS TO FALSE
          store.dispatch(setFetchIntentState(null))
        } else if (data?.error) {
          // SET INTENT API CALL IN PROGRESS TO FALSE
          store.dispatch(setFetchIntentState(null))
          callToaster(toast.TYPE.ERROR, 'Intent Fetch Failed')
        } else if (data?.start) {
          // SET INTENT FETCHING STATE TO NEWEST TIMESTAMP TO ALWAYS SHOW LATEST GRID
          store.dispatch(setFetchIntentState(data?.timestamp))
        } else if (data?.end && data?.timestamp === intentTimestamp) {
          // IF LATEST INTENT RESPONSE RECEIVED ONLY THEN SET IT
          // CAN BE THE CASE THAT 2 INTENTS GRIDS ARE FETCHING AT SAME TIME
          // SET INTENT RESPONSE
          store.dispatch({
            type: SET_INTENT_GRID,
            payload: data,
          })
          store.dispatch(setFetchIntentState(null))
        }
      } else if (event === 'receive_message') {
        // UPDATE LAST ACTIVE TIME
        // USED TO CHECK HOW LONG CONVERSATION HAS BEEN IN ACTIVE
        store.dispatch({
          type: SET_LAST_ACTIVE_TIME,
          payload: Date.now(),
        })

        logToConsole('SOCKET.IO MAYA receive_message', data)
        if (data?.start) {
          // STARTS NEW ASSISTANT MESSAGE RESPONSE
          // ADD A NEW BLANK ASSISTANT MESSAGE
          if (store.getState().maya.isExpectingAssistantResponse) {
            // ONLY ACCEPT STREAMING RESPONSE IF THIS MESSAGE IS SENT BY CURRENT SOCKET
            // AS STREAMING WILL ONLY BE FOR THE SOCKET SENDING IT, REST WILL RECEIVE A COMPLETE RESPONSE
            store.dispatch(addMayaResponse(data))
          }
          store.dispatch(setIsMayaResponding(true))
        } else if (data?.end && data?.tempId && data?.id) {
          // UPDATE LAST ACTIVE TIME
          // USED TO CHECK HOW LONG CONVERSATION HAS BEEN IN ACTIVE
          store.dispatch({
            type: SET_LAST_ACTIVE_TIME,
            payload: Date.now(),
          })

          // UPDATE THE TEMP ASSISTANT RESPONSE ID WITH ACTUAL DB ID
          store.dispatch(updateAssistantResponseId(data?.tempId, data?.id))

          // ENDS CURRENT ASSISTANT RESPONSE
          store.dispatch(isExpectingAssistantResponse(false))
          store.dispatch(setIsMayaResponding(false))
        } else if (data?.abusive) {
          store.dispatch(isExpectingAssistantResponse(false))
          store.dispatch(setIsMayaResponding(false))
        } else if (data?.error) {
          store.dispatch(isExpectingAssistantResponse(false))
          store.dispatch(setIsMayaResponding(false))
          store.dispatch(setRegenerateResponse(true))
        } else {
          // UPDATE LAST ACTIVE TIME
          // USED TO CHECK HOW LONG CONVERSATION HAS BEEN IN ACTIVE
          store.dispatch({
            type: SET_LAST_ACTIVE_TIME,
            payload: Date.now(),
          })

          // ONLY ACCEPT STREAMING RESPONSE IF THIS MESSAGE IS SENT BY CURRENT SOCKET
          // AS STREAMING WILL ONLY BE FOR THE SOCKET SENDING IT, REST WILL RECEIVE A COMPLETE RESPONSE
          if (store.getState().maya.isExpectingAssistantResponse) {
            store.dispatch(setMayaChatResponse({ chunk: data }))
          } else {
            logToConsole('Setting maya responding to true')
            // STILL SET IS MAYA RESPONDING TO TRUE SO THAT USER KNOWS AI RESPONSE IS GENERATING
            // ALSO USER CANT SENT NEW MESSAGE
            store.dispatch(setIsMayaResponding(true))
          }
        }
      } else if (event === 'remove_existing_message') {
        // UPDATE LAST ACTIVE TIME
        // USED TO CHECK HOW LONG CONVERSATION HAS BEEN IN ACTIVE
        store.dispatch({
          type: SET_LAST_ACTIVE_TIME,
          payload: Date.now(),
        })

        logToConsole('SOCKET.IO MAYA remove_existing_message', data)

        // IF MESSAGE EXISTS IN CONVERSATION LOG OF CURRENT TAB IT'LL BE REMOVED
        store.dispatch(removeExistingMessage(data))
      } else if (event === 'new_message') {
        // UPDATE LAST ACTIVE TIME
        // USED TO CHECK HOW LONG CONVERSATION HAS BEEN IN ACTIVE
        store.dispatch({
          type: SET_LAST_ACTIVE_TIME,
          payload: Date.now(),
        })

        logToConsole('SOCKET.IO MAYA new_message', data)
        store.dispatch(addNewMessage(data))
      } else if (event === 'new_assistant_messages') {
        // UPDATE LAST ACTIVE TIME
        // USED TO CHECK HOW LONG CONVERSATION HAS BEEN IN ACTIVE
        store.dispatch({
          type: SET_LAST_ACTIVE_TIME,
          payload: Date.now(),
        })

        logToConsole('SOCKET.IO MAYA new_assistant_messages', data)
        let lastMessage =
          store.getState().maya.messages[
            store.getState().maya.messages.length - 1
          ]

        // IF ASSISTANT RESPONSE COMING IN REPLY OF CURRENT APP INSTANCE THEN DON'T CATER IT
        // ITS ALREADY CATERED IN ON STREAMING
        if (
          lastMessage?.content &&
          data?.length &&
          lastMessage?.content !== data[0]?.content
        ) {
          // ANIMATE INCOMING ASSISTANT RESPONSE
          animateDefaultMessages(data, 0, 0)
        }
      } else if (event === 'update_existing_message') {
        // UPDATE LAST ACTIVE TIME
        // USED TO CHECK HOW LONG CONVERSATION HAS BEEN IN ACTIVE
        store.dispatch({
          type: SET_LAST_ACTIVE_TIME,
          payload: Date.now(),
        })

        logToConsole('SOCKET.IO MAYA update_existing_message', data)

        // UPDATES EXISTING MESSAGE
        store.dispatch({
          type: UPDATE_EXISTING_MESSAGE,
          payload: data,
        })
      } else if (event === 'validation_error') {
        // HANDLE SOCKET VALIDATION ERROR
        handleSocketValidationError()
      } else if (event === 'user_joined_room') {
        // SET SOCKET CONNECTION ESTABLISHED TO TRUE
        // SO THAT USER CAN START SENDING MESSAGES
        store.dispatch(setSocketConnectionEstablished(true))

        logToConsole('SOCKET.IO MAYA user_joined_room', data['roomId'])
        // SET DEFAULT ROOM NAME FOR CHAT IF IT DOESNT EXIST ALREADY
        if (!socketInstance.getValues().socketRoomName) {
          // GET DEFAULT TRIPS TO SHOW, ONLY FIRST TIME
          // GET DEFAULT TRIPS ONLY IF ITS NOT AN EXISTING CHAT WITH AN EXISTING INTENT
          if (!store.getState().maya.intent) {
            store.dispatch(getDefaultTrips())
          }

          // SET SOCKET ROOM NAME
          socketInstance.setValues({ socketRoomName: data['roomId'] })
        }
      } else if (event === 'receive_search_query_response_message') {
        logToConsole(
          'SOCKET.IO MAYA receive_search_query_response_message',
          data
        )
        if (data?.start) {
          store.dispatch(setMayaAiQueryResponse(''))
          store.dispatch(setMayaAiQueryToken(data?.token))
        } else if (data?.end) {
          store.dispatch(setIsFetchingAiQueryResponse(false))
        } else if (data?.error) {
        } else if (store.getState().maya.aiSearchQueryToken === data?.token) {
          // CHECK TOKEN OF AI SEARCH QUERY RESPONSE MATCHES SO THAT MULTIPLE RESPONSES DONT GET OVERRIDED
          store.dispatch(setIsFetchingAiQueryResponse(false))
          let currResp = store.getState().maya.searchAiTextResponse
          store.dispatch(setMayaAiQueryResponse(currResp + data?.content || ''))
        }
      }
    })
    socketInstance.getValues().socket.on('connect_error', err => {
      logToConsole('SOCKET.IO MAYA connect_error', err)

      // AUTO RECONNECTS, NO NEED TO HANDLE
    })
    socketInstance.getValues().socket.on('connect_failed', err => {
      logToConsole('SOCKET.IO MAYA connect_failed', err)

      // HANDLE SOCKET CONNECTION ERROR
      handleSocketError()
    })
    socketInstance.getValues().socket.on('disconnect', err => {
      logToConsole('SOCKET.IO MAYA disconnect', err)

      // SOCKET AUTO CONNECTS AGAIN, NO NEED TO HANDLE
    })
    socketInstance.getValues().socket.on('close', err => {
      logToConsole('SOCKET.IO MAYA close', err)
    })
    socketInstance.getValues().socket.on('connect', () => {
      logToConsole('SOCKET.IO MAYA connect')

      // ON CONNECTION IF CLIENT HAS ANY EXISTING SOCKET ROOM, JOIN IT
      if (socketInstance.getValues().socketRoomName) {
        logToConsole(
          'SOCKET.IO MAYA connect to room',
          socketInstance.getValues().socketRoomName
        )

        socketInstance.getValues().socket.emit('join_room', {
          roomId: socketInstance.getValues().socketRoomName,
        })
      }
    })
    socketInstance.getValues().socket.on('reconnect_attempt', attempt => {
      logToConsole('SOCKET.IO MAYA reconnect_attempt', attempt)
    })
  } else {
    //  KEEP ON LOOPING UNTIL ORGANIZATION CONFIG FOUND AND SET
    setTimeout(() => {
      setSocketListeners()
    }, 100)
  }
}
// setSocketListeners()
// SOCKETS HANDLING END

const checkIfUserIdle = () => {
  const currTime = Date.now()

  const organizationDetails = store.getState().maya.organizationDetails
  const lastActiveTime = store.getState().maya.lastActiveTime
  const userHasSentMessage = store.getState().maya.userHasSentMessage
  const isMayaResponding = store.getState().maya.isMayaResponding
  const isExpectingAssistantResponse =
    store.getState().maya.isExpectingAssistantResponse

  if (
    organizationDetails &&
    organizationDetails?.configs?.length &&
    !organizationDetails?.configs[0].enableCustomerFeedbackModal
  ) {
    logToConsole(
      `Organization ${organizationDetails?.name} doesn't support customer feedback modal.`
    )
    return
  }

  if (
    !organizationDetails ||
    !lastActiveTime ||
    !userHasSentMessage ||
    isMayaResponding ||
    isExpectingAssistantResponse
  ) {
    setTimeout(() => {
      checkIfUserIdle()
    }, 1000)
    return
  }

  const idleTime = currTime - lastActiveTime

  logToConsole(`User is inactive for ${idleTime / 1000} seconds`)

  let idleTimeProduction = 120000

  if (process.env.REACT_APP_API_ENV === 'dev') {
    idleTimeProduction = 6000
  }

  if (idleTime > idleTimeProduction) {
    logToConsole('User idle for more than 120 seconds. Show feedback modal.')
    store.dispatch({ type: SET_SHOW_FEEDBACK_MODAL, payload: true })
  } else {
    setTimeout(() => {
      checkIfUserIdle()
    }, 1000)
  }
}

// SLEEP FOR A GIVEN NUMBER OF MILLISECONDS
const sleep = async ms => {
  return new Promise(resolve => setTimeout(resolve, ms))
}

// POLL AND CHECK IF USER MESSAGES TO SEND ARE AVAILABLE
const pollAndCheckUserMessagesToSend = () => {
  setTimeout(async () => {
    if (
      userMessagesToSend.length > 0 &&
      !store.getState().maya.isMayaResponding
    ) {
      console.log('Sending message to Maya', userMessagesToSend[0])
      const message = userMessagesToSend.shift().message
      await store.dispatch(setIsPopoverChatOpen(true))
      sendMessageToMaya({ message })

      // SLEEP FOR 2 SECONDS BEFORE SENDING NEXT MESSAGE
      // WORKAROUND TO SEND MULTIPLE MESSAGES AT ONCE, BEFORE A AI RESPONSE IS COMPLETELY FINISHED
      await sleep(2000)
    }
    pollAndCheckUserMessagesToSend()
  }, 250)
}

// CHECK IF USER IS IDLE EVERY 1 SECOND
checkIfUserIdle()

// POLL AND CHECK IF USER MESSAGES TO SEND ARE AVAILABLE
pollAndCheckUserMessagesToSend()
